
import React, { useState, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const PrivateRoute = ({ children, role }) => {
  const auth = getAuth();
  const db = getFirestore();
  const location = useLocation();

  const [user, setUser] = useState(() => JSON.parse(localStorage.getItem("user")) || null);
  const [userRole, setUserRole] = useState(() => localStorage.getItem("userRole") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (loggedInUser) => {
      if (loggedInUser) {
        setUser(loggedInUser);
        localStorage.setItem("user", JSON.stringify(loggedInUser));

        // Fetch user role from Firestore
        const userDocRef = doc(db, "users", loggedInUser.uid);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const fetchedRole = userDocSnap.data().role;
          setUserRole(fetchedRole);
          localStorage.setItem("userRole", fetchedRole);
        } else {
          setUserRole(null);
          localStorage.removeItem("userRole");
        }
      } else {
        setUser(null);
        setUserRole(null);
        localStorage.removeItem("user");
        localStorage.removeItem("userRole");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [auth, db]);

  if (loading) {
    return <p>Loading...</p>; // Prevent redirect while checking authentication
  }

  if (!user) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (role !== userRole) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;